import { parseReferenceString } from '@seen/core/utils'

import { Button, cn } from '@seen/ui'
import { IconPlus } from '@tabler/icons-react'
import type { JSX } from 'react'
import { UserPlaceholderNameplate } from '#src/components/nameplates/UserPlaceholderNameplate.tsx'
import { ParticipantNameplateLink } from '#src/components/ParticipantNameplateLink.tsx'
import { TaskRowCheckbox } from '#src/components/TaskRowCheckbox.tsx'
import {
  type TaskComposerDefaultValues,
  useTaskComposerStore,
} from '#src/hooks/useTaskComposerStore.ts'

export interface TaskListParticipantGroupHeaderProps {
  participant: string | null
  defaultValues?: TaskComposerDefaultValues
  hideCheckbox?: boolean
  checked?: boolean
  onCheckedChange?: (value: boolean) => void
}

export function TaskListParticipantGroupHeader({
  participant: participantReferenceString,
  defaultValues,
  hideCheckbox,
  checked,
  onCheckedChange,
}: TaskListParticipantGroupHeaderProps): JSX.Element {
  const setOpen = useTaskComposerStore((state) => state.setOpen)
  const setDefaultValues = useTaskComposerStore(
    (state) => state.setDefaultValues
  )

  const handleAddTask = (): void => {
    setOpen(true)
    setDefaultValues({
      ...defaultValues,
      ...(participantReferenceString && {
        participant: parseReferenceString(participantReferenceString),
      }),
    })
  }

  return (
    <div
      className={cn(
        'group flex items-center justify-between bg-frame px-pagex-default lg:px-pagex-lg',
        !hideCheckbox && 'pr-8 pl-0 lg:pr-8 lg:pl-0'
      )}
    >
      {!hideCheckbox && (
        <TaskRowCheckbox value={checked} onChange={onCheckedChange} />
      )}
      <div className="-ml-0.5 flex flex-1 items-center text-sm">
        {participantReferenceString && (
          <ParticipantNameplateLink participant={participantReferenceString} />
        )}
        {!participantReferenceString && (
          <UserPlaceholderNameplate>No participant</UserPlaceholderNameplate>
        )}
      </div>
      <Button
        variant="ghost"
        size="icon"
        className={cn(
          'ml-2 rounded-none',
          '-mr-2.5' // Align with the task row
        )}
        onClick={handleAddTask}
      >
        <IconPlus className="size-4" />
      </Button>
    </div>
  )
}
